import axios from 'axios';
import moment from 'moment';
import apiConfig from 'src/api/APIConfig';
import config from 'src/appConfig';
import { updateUserAccessMessage } from 'src/components/common/AccessMessage';
import { getPoratlHost } from 'src/components/common/hooks/useUtil';
import { store, useAppSelector } from 'src/store';
const isfInstance = axios.create({ baseURL: `${config.appConfig.apiisf}` });

type Callback = (progress: number) => void;

/**
 *
 */
class DocManagementService {
  /**
   *
   * @param file
   */

  async fileUpload(
    file: any,
    progressUpload: Callback,
    isfLevel: string,
    study: string,
    country: string,
    site: string,
    application: any,
    module: string,
    entity: string
  ) {
    const formData = new FormData();
    formData.append('file', file);
    const newState = store.getState();
    const headerConfig = {
      headers: {
        'Content-Type': 'multipart/form-data',
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.post(
        `${config.appConfig.apiisf}/fileMaster/uploadFile?isf_doc_level=${isfLevel}&study_id=${study}&country_id=${country}&site_id=${site}&application=${application}&module_section_related=${module}&parent_entity_related=${entity}`,
        formData,
        headerConfig
      );
      return { data: response, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getArtifactsList(
    isfLevel: any,
    study = '',
    country = '',
    site = '',
    application: any,
    module: string,
    entity: string
  ) {
    let type = '';
    if (study != '--' && country == '--' && site == '--') {
      type = `?isf_doc_study=${study}`;
    } else if (country != '--' && site == '--') {
      type = `?isf_doc_study=${study}&isf_doc_country=${country}`;
    } else if (site != '--') {
      type = `?isf_doc_study=${study}&isf_doc_country=${country}&isf_doc_site=${site}`;
    }
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.get(
        `${config.appConfig.apiisf}/isfLevel/${isfLevel}/select${type}&application=${application}&module_section_related=${module}&parent_entity_related=${entity}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getArtifactNameResponse(
    isfDocLevel: any,
    artifactName: any,
    study: string,
    country: string,
    site: string,
    application: any,
    module: string,
    entity: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.get(
        `${config.appConfig.apiisf}/isfLevel/docInfo/${isfDocLevel}/select?isf_artifact_name=${encodeURIComponent(
          artifactName
        )}&study_id=${study}&country_id=${country}&site_id=${site}&application=${application}&module_section_related=${module}&parent_entity_related=${entity}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async createMasterDocument(docData: any, application: any, module: string, entity: string) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.post(
        `${config.appConfig.apiisf}/masterDocument/create?application=${application}&module_section_related=${module}&parent_entity_related=${entity}`,
        docData,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }
  async getStudyList(value: any) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.get(
        `${config.appConfig.apictms}/study/country/${value}/select`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async updatedVersionData(docData: any, application: any, module: string, entity: string) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.put(
        `${config.appConfig.apiisf}/masterDocument/update?application=${application}&module_section_related=${module}&parent_entity_related=${entity}`,
        docData,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getSearchResult(
    data: any,
    study: string,
    country: string,
    site: string,
    isfLevel: string,
    is_scope?: boolean,
    application?: any,
    module?: string,
    entity?: string,
    from = -1,
    size = -1
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.post(
        `${
          config.appConfig.apiisf
        }/masterDocument/advanceSearch/select?country_id=${country}&site_id=${site}&study_id=${study}&isf_doc_level=${isfLevel}&is_scope=${is_scope}&application=${application}&module_section_related=${module}&parent_entity_related=${entity}&sort_by=created_on&sort_order=asc${
          from > -1 ? `&from=${from}` : ''
        }${size > -1 ? `&size=${size}` : ''}`,
        data,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getSubArtifactVersionDetails(
    isfLevel: any,
    isfDocStudy: any,
    isfDocCountry: any,
    isfDocSite: any,
    isfArtifactName: any,
    application?: any,
    module?: string,
    entity?: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.get(
        `${
          config.appConfig.apiisf
        }/masterDocument/subArtifact/versions?isf_doc_level=${isfLevel}&isf_doc_study=${isfDocStudy}&isf_doc_country=${isfDocCountry}&isf_doc_site=${isfDocSite}&isf_artifact_name=${encodeURIComponent(
          isfArtifactName
        )}&application=${application}&module_section_related=${module}&parent_entity_related=${entity}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getVersionHistory(
    isfDocId: any,
    study: string,
    country: string,
    site: string,
    isfLevel: string,
    application?: any,
    module?: string,
    entity?: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.get(
        `${config.appConfig.apiisf}/masterDocument/versionHistory?isf_document_id=${isfDocId}&study_id=${study}&country_id=${country}&site_id=${site}&isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}&parent_entity_related=${entity}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getMasterDocumentdetails(
    study: string,
    isfDocId: any,
    version: any,
    country: string,
    site: string,
    isfLevel: string,
    application?: any,
    module?: string,
    entity?: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.get(
        `${config.appConfig.apiisf}/masterDocument/${study}/select?site_id=${site}&country_id=${country}&isf_document_id=${isfDocId}&isf_doc_version_number=${version}&isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}&parent_entity_related=${entity}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  // Not used in ISF //
  async getQCDetails(id: any) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.get(
        `${config.appConfig.apietmf}/qualityControl/${id}/select`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getMasterDocumentAuditdetails(
    isfDocStudy: any,
    docID: string,
    country: string,
    site: string,
    isfLevel: string,
    application?: any,
    module?: string,
    entity?: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.get(
        `${config.appConfig.apiisf}/masterDocument/${isfDocStudy}/select?document_id=${docID}&site_id=${site}&country_id=${country}&isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}&parent_entity_related=${entity}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async updateMasterDocument(docData: any, application: any, module: string, entity: string, isRedacted: boolean) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.put(
        `${config.appConfig.apiisf}/masterDocument/inlineUpdate?application=${application}&module_section_related=${module}&parent_entity_related=${entity}&is_redacted=${isRedacted}`,
        docData,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error };
    }
  }

  async getMasterDocumentAllSession(
    isfLevel: string,
    study: string,
    country: string,
    site: string,
    application: any,
    module: string,
    entity: string,
    binder: boolean
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.get(
        `${config.appConfig.apiisf}/masterDocument/getAll?isf_doc_level=${isfLevel}&study_id=${study}&country_id=${country}&site_id=${site}&application=${application}&module_section_related=${module}&parent_entity_related=${entity}&is_binder_view=${binder}&limit=100`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getMasterDocumentArtifactBased(
    binder: boolean,
    artifactNumber: string,
    study: string,
    country: string,
    site: string,
    application: any,
    module: string,
    isfLevel: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    let type = '';
    if (study !== '--' && country === '--' && site === '--') {
      type = `study_id=${study}`;
    } else if (country !== '--' && site === '--') {
      type = `study_id=${study}&country_id=${country}`;
    } else if (site !== '--') {
      type = `study_id=${study}&country_id=${country}&site_id=${site}`;
    }

    try {
      const response: any = await isfInstance.get(
        `${config.appConfig.apiisf}/masterDocument/getAll?is_binder_view=${binder}&isf_artifact_number=${artifactNumber}&${type}&application=${application}&module_section_related=${module}&isf_doc_level=${isfLevel}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getMasterDocumentsByUser(
    study: string,
    country: string,
    site: string,
    isBinder: boolean,
    isfLevel: string,
    application: any,
    module: string,
    entity: string,
    originally_uploaded: boolean,
    from = -1,
    size = -1
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      let params;
      if (study === '--' && country === '--' && site === '--') {
        params = '';
      } else if (study !== '--' && country === '--' && site === '--') {
        params = `study_id=${study}&`;
      } else if (study !== '--' && country !== '--' && site === '--') {
        params = `study_id=${study}&country_id=${country}&`;
      } else if (study !== '--' && country !== '--' && site !== '--') {
        params = `study_id=${study}&country_id=${country}&site_id=${site}&`;
      }
      const response: any = await isfInstance.get(
        `${
          config.appConfig.apiisf
        }/masterDocument/getAll?${params}is_binder_view=${isBinder}&isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}&parent_entity_related=${entity}&user_based_details=true&originally_uploaded=${originally_uploaded}${
          from > -1 ? `&from=${from}` : ''
        }${size > -1 ? `&size=${size}` : ''}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async deleteDocumentDetails(
    fileMasterId: any,
    isfDocumentId: any,
    deleteDoc: any,
    study: string,
    country: string,
    site: string,
    isfLevel: string,
    application: any,
    module: string,
    entity: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.patch(
        `${config.appConfig.apiisf}/masterDocument/${fileMasterId}/delete?isf_document_id=${isfDocumentId}&study_id=${study}&country_id=${country}&site_id=${site}&isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}&parent_entity_related=${entity}`,
        deleteDoc,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getAuditDetails(
    isfId: any,
    size: number,
    order: string,
    data: any,
    study: string,
    country: string,
    site: string,
    isfLevel: string,
    application: any,
    module: string,
    entity: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response = await isfInstance.post(
        `${config.appConfig.apiisf}/audit/applyFilter/select?from=0&size=${size}&isf_document_id=${isfId}&sort_by=created_on&sort_order=${order}&study_id=${study}&country_id=${country}&site_id=${site}&isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}&parent_entity_related=${entity}`,
        data,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  // Not used in ISF //
  async documentSubmitForReview(quality_control_id: any, users: any) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const data = { quality_control_id, users, is_submit: true };
      const response: any = await isfInstance.post(
        `${config.appConfig.apietmf}/qualityControlUser/update`,
        data,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getAllUsers(study: string, isf_doc_level: string, isf_artifact_name: any, country: string, site: string) {
    const newState = store.getState();
    try {
      const headerConfig = {
        headers: {
          sponsor: newState.user.user?.sponsor_sponsor_name,
          sponsor_token: newState.user.user?.sponsorToken,
          Authorization: `Bearer ${newState.user.user?.token}`,
          user_date_time: moment().format()
        }
      };
      let type = '';
      if (country !== '--' && site === '--') {
        type = `country=${country}`;
      } else if (site !== '--') {
        type = `country=${country}&site_id=${site}`;
      }

      const response: any = await isfInstance.get(
        `${apiConfig.appConfig.apiutilsIsf}/utils/${study}/${isf_doc_level}/${isf_artifact_name}/users?${type}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getSearchSuggestions(
    searchText: string,
    filter_types: any,
    isfLevel: string,
    application: any,
    module: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const body = filter_types;
      const response: any = await isfInstance.post(
        `${config.appConfig.apiisf}/audit/suggestions/${searchText}?isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}`,
        body,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getAnnotations(
    file_master_id: any,
    study: string,
    country: string,
    site: string,
    isfLevel: string,
    application: any,
    module: string,
    entity: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.get(
        `${config.appConfig.apiisf}/fileComment/${file_master_id}/comments/get?study_id=${study}&country_id=${country}&site_id=${site}&isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}&parent_entity_related=${entity}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async sendAnnotations(
    file_master_id: any,
    xfdfString: any,
    study: string,
    country: string,
    site: string,
    isfLevel: string,
    application: any,
    module: string,
    entity: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const data = { comments: xfdfString };
      const response: any = await isfInstance.post(
        `${config.appConfig.apiisf}/fileComment/${file_master_id}/store/comment?study_id=${study}&country_id=${country}&site_id=${site}&isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}&parent_entity_related=${entity}`,
        data,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getGlobalSearch(
    searchObj: any,
    study: string | null,
    country: string | null,
    site: string | null,
    isfLevel: string,
    application?: any,
    module?: string,
    from = -1,
    size = -1
  ) {
    const newState = store.getState();
    const isStudy = study === '--' ? false : true;
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const body = searchObj;
      const response: any = await isfInstance.post(
        `${config.appConfig.apiisf}/masterDocument/advanceSearch/select?is_scope=${isStudy}${
          country !== null && country !== '--' ? `&country_id=${country}` : ''
        }${site !== null && site !== '--' ? `&site_id=${site}` : ''}${
          study !== null && site !== '--' ? `&study_id=${study}` : ''
        }&isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}${
          from > -1 ? `&from=${from}` : ''
        }${size > -1 ? `&size=${size}` : ''}`,
        body,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async createFilterPreset(
    filterData: any,
    study: string,
    country: string,
    site: string,
    isfLevel: string,
    application?: any,
    module?: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.post(
        `${config.appConfig.apiisf}/savePreset/create?country_id=${country}&site_id=${site}&study_id=${study}&isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}`,
        filterData,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getAllFilterPresets(
    study: string,
    country: string,
    site: string,
    isfLevel: string,
    application?: any,
    module?: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.get(
        `${config.appConfig.apiisf}/savePreset/getAll?country_id=${country}&site_id=${site}&study_id=${study}&isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getCodeList(
    code: string,
    study: string,
    country: string,
    site: string,
    isfLevel: string,
    application?: any,
    module?: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.get(
        `${config.appConfig.apiisf}/codeList/${code}/select?country_id=${country}&site_id=${site}&study_id=${study}&isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async updatePresetFilter(
    presetData: any,
    study: string,
    country: string,
    site: string,
    isfLevel: string,
    application?: any,
    module?: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.put(
        `${config.appConfig.apiisf}/savePreset/update?country_id=${country}&site_id=${site}&study_id=${study}&isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}`,
        presetData,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async deletePresetFilter(
    presetId: any,
    presetData: any,
    study: string,
    country: string,
    site: string,
    isfLevel: string,
    application?: any,
    module?: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.patch(
        `${config.appConfig.apiisf}/savePreset/${presetId}/delete?country_id=${country}&site_id=${site}&study_id=${study}&isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}`,
        presetData,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getAllPlanning(
    level: string,
    study: string,
    country: string,
    site: string,
    application?: any,
    module?: string,
    from = -1,
    size = -1
  ) {
    let type = '';
    if (study != '--' && country != '--' && site != '--') {
      type = `isf_doc_level=${level}&isf_doc_study=${study}&isf_doc_country=${country}&isf_doc_site=${site}`;
    }
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.get(
        `${
          config.appConfig.apiisf
        }/isfLevel/plan/getAll?${type}&application=${application}&module_section_related=${module}${
          from > -1 ? `&from=${from}` : ''
        }${size > -1 ? `&size=${size}` : ''}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error };
    }
  }

  async sendEmail(
    key: any,
    documentName: any,
    message: any,
    data: any[],
    user: any,
    study: string,
    country: string,
    site: string,
    isfLevel: string,
    application?: any,
    module?: string,
    entity?: string
  ) {
    const appName = 'ISF';
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const emails = data.map(obj => {
        return {
          user_id: obj?.id,
          user_name: obj?.user_name,
          recipient: obj.email
        };
      });
      const baseUrl = `${getPoratlHost()}?application=${appName}&key=`;
      const reqData = {
        ui_url: baseUrl,
        hashed_uri_key: key,
        user_name: `${user.firstName + ' ' + user.lastName}`,
        subject: documentName,
        body: message,
        sent_by: user.email,
        recipients: emails
      };
      const response: any = await isfInstance.post(
        `${config.appConfig.apiisf}/email/send?country_id=${country}&site_id=${site}&study_id=${study}&isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}&parent_entity_related=${entity}`,
        reqData,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async updatePlanningField(data: any, application?: any, module?: string, entity?: string) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.put(
        `${config.appConfig.apiisf}/isfLevel/plan/${data.isf_level_map_id}/update?application=${application}&module_section_related=${module}&parent_entity_related=${entity}`,
        data,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getAllTasks(
    study: string,
    country: string,
    site: string,
    isfLevel: string,
    application: any,
    module: string,
    from = -1,
    size = -1
  ) {
    const type = `isf_doc_study=${study}&isf_doc_country=${country}&isf_doc_site=${site}`;
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.get(
        `${
          config.appConfig.apiisf
        }/Task/getAll?${type}&isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}${
          from > -1 ? `&from=${from}` : ''
        }${size > -1 ? `&size=${size}` : ''}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async createTask(
    documentId: any,
    docData: any,
    isWorkFlow: boolean,
    study: string,
    country: string,
    site: string,
    isfLevel: string,
    application: any,
    module: string,
    entity: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.post(
        `${config.appConfig.apiisf}/Task/${documentId}/create?is_work_flow=${isWorkFlow}&study_id=${study}&country_id=${country}&site_id=${site}&isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}&parent_entity_related=${entity}`,
        docData,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async updateTask(
    taskId: string,
    data: any,
    study: string,
    country: string,
    site: string,
    isfLevel: string,
    application: any,
    module: string,
    entity: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.put(
        `${config.appConfig.apiisf}/Task/${taskId}/update?study_id=${study}&country_id=${country}&site_id=${site}&application=${application}&isf_doc_level=${isfLevel}&module_section_related=${module}&parent_entity_related=${entity}`,
        data,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getActionName(
    documentId: string,
    userBased: boolean,
    study: string,
    country: string,
    site: string,
    isfLevel: string,
    application?: any,
    module?: string,
    entity?: string,
    isReview?: boolean
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.get(
        `${config.appConfig.apiisf}/Task/${documentId}/select?user_based_action=${userBased}&country_id=${country}&site_id=${site}&study_id=${study}&isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}&parent_entity_related=${entity}&is_sent_for_review=${isReview}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async completeReview(
    taskId: string,
    data: any,
    study: string,
    country: string,
    site: string,
    isfLevel: string,
    application?: any,
    module?: string,
    entity?: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.put(
        `${config.appConfig.apiisf}/Task/${taskId}/update?country_id=${country}&site_id=${site}&study_id=${study}&isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}&parent_entity_related=${entity}`,
        data,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }
  async RejectReview(
    taskId: string,
    data: any,
    study: string,
    country: string,
    site: string,
    isfLevel: string,
    application?: any,
    module?: string,
    entity?: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.put(
        `${config.appConfig.apiisf}/Task/${taskId}/reject?is_work_flow=true&country_id=${country}&site_id=${site}&study_id=${study}&isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}&parent_entity_related=${entity}`,
        data,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }
  async reviewFeedback(
    taskId: string,
    data: any,
    study: string,
    country: string,
    site: string,
    isfLevel: string,
    application?: any,
    module?: string,
    entity?: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.put(
        `${config.appConfig.apiisf}/Task/${taskId}/reviewFeedback?is_work_flow=true&country_id=${country}&site_id=${site}&study_id=${study}&isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}&parent_entity_related=${entity}`,
        data,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }
  async updateStatus(
    taskId: string,
    data: any,
    study: string,
    country: string,
    site: string,
    isfLevel: string,
    application?: any,
    module?: string,
    entity?: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.post(
        `${config.appConfig.apiisf}/Task/approvalWorkflow/${taskId}/updateStatus?country_id=${country}&site_id=${site}&study_id=${study}&isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}&parent_entity_related=${entity}`,
        data,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  getIsfLevelBy(study: any, country: any, site: any) {
    let IsfLevel =
      (study === '--' || study === '') && (country === '--' || country == '') && (site === '--' || site === '')
        ? '--'
        : (country === '--' || country == '') && (site === '--' || site === '')
        ? 'Study'
        : site === '--' && country != '--'
        ? 'Country'
        : 'Site';
    if (IsfLevel === '--') {
      IsfLevel = 'Study';
    }
    return IsfLevel;
  }

  async getBinderViewerTree(
    study: string,
    country: string,
    site: string,
    isfLevel: string,
    application?: any,
    module?: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.get(
        `${config.appConfig.apiisf}/isfLevel/binderViewer/getAll?country_id=${country}&site_id=${site}&study_id=${study}&isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getRecentDocumentApi() {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.get(`${config.appConfig.apiisf}/masterDocument/getAll`, headerConfig);
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getRecentDocumentsByUser(
    study: any,
    country: any,
    site: any,
    isfLevel: string,
    application?: any,
    module?: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.get(
        `${config.appConfig.apiisf}/masterDocument/getAll?country_id=${country}&site_id=${site}&study_id=${study}&is_binder_view=true&user_based_details=true&isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getRecentDocumentsAllSession(isfLevel = '--', study = '--', country = '--', site = '--') {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      let params;
      if (study === '--' && country === '--' && site === '--') {
        params = '';
      } else if (study !== '--' && country === '--' && site === '--') {
        params = `isf_doc_level=${isfLevel}&study_id=${study}&`;
      } else if (study !== '--' && country !== '--' && site === '--') {
        params = `isf_doc_level=${isfLevel}&study_id=${study}&country_id=${country}&`;
      } else if (study !== '--' && country !== '--' && site !== '--') {
        params = `isf_doc_level=${isfLevel}&study_id=${study}&country_id=${country}&site_id=${site}&`;
      } else {
        params = `country_id=${country}&site_id=${site}&study_id=${study}&tmf_doc_level=${isfLevel}&`;
      }
      const response: any = await isfInstance.get(
        `${config.appConfig.apiisf}/masterDocument/getAll?${params}is_binder_view=false&limit=100`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      return { data: null, error: error.message };
    }
  }

  // Not used in ISF //
  async getMasterDocumentAllSessionisfBinderViewer(
    payload: any,
    level: number,
    nodes: any,
    study: string,
    country: string,
    site: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const isf_doc_type = payload.documentType;
      const isf_doc_subtype = payload.documentSubType;
      const isf_artifact_number = payload.artifactNumber;
      let type = '';
      if (level === 1) {
        type = `isf_doc_type=${nodes[0]}`;
      } else if (level === 2) {
        type = `isf_doc_type=${nodes[0]}&isf_doc_subtype=${nodes[1]}`;
        window.scrollTo(0, 0);
      } else if (level === 3) {
        type = `isf_doc_type=${nodes[0]}&isf_doc_subtype=${nodes[1]}&isf_artifact_number=${nodes[2]}`;
        window.scrollTo(0, 0);
      }
      const response: any = await isfInstance.get(
        `${config.appConfig.apiisf}/masterDocument/getAll?country_id=${country}&site_id=${site}&study_id=${study}&${type}&is_binder_view=false&limit=100`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getDocument(
    viewerDoc: any,
    study: string,
    country: string,
    site: string,
    isfLevel: string,
    application?: any,
    module?: string,
    entity?: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      let response: any;
      if (viewerDoc.study_id === '') {
        response = await isfInstance.get(
          `${config.appConfig.apiisf}/hashedLink/${viewerDoc.document_id}/getLink?country_id=${country}&site_id=${site}&study_id=${study}&isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}&parent_entity_related=${entity}`,
          headerConfig
        );
      } else {
        response = await isfInstance.get(
          `${config.appConfig.apiisf}/masterDocument/${viewerDoc.study_id}/select?site_id=${viewerDoc.site_id}&country_id=${viewerDoc.country}&document_id=${viewerDoc.document_id}&latest_version_hyperlink=false&isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}&parent_entity_related=${entity}`,
          headerConfig
        );
      }
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.response.status };
    }
  }

  async getMilestoneList(
    isfLevel: any,
    study: string,
    country: string,
    site: string,
    application?: any,
    module?: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.get(
        `${config.appConfig.apiisf}/isfLevel/landing/${isfLevel}/getMilestones?country_id=${country}&site_id=${site}&study_id=${study}&application=${application}&module_section_related=${module}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getSysAdminUsers() {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.get(`${config.appConfig.apiSysAdmin}/sysAdmin/users`, headerConfig);
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getDocumentStatusRecords(
    isfLevel: any,
    study: any,
    country: any,
    site: any,
    docType: any,
    docSubType: any,
    artifact: any,
    milestone: any,
    statusList: any,
    owner: any,
    dataSince: any,
    application?: any,
    module?: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.post(
        `${config.appConfig.apiisf}/masterDocument/${isfLevel}/${study}/getStatusMetric?isf_doc_country=${country}&isf_doc_site=${site}&isf_doc_type=${docType}&isf_doc_subtype=${docSubType}&isf_artifact_name=${artifact}&isf_doc_milestone=${milestone}&isf_doc_viewer_created_by=${owner}&delta_months=${dataSince}&application=${application}&module_section_related=${module}`,
        statusList,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  /**
   * Bharath
   * @param document
   * @returns
   */
  async getDocAccessPermissions(document: any) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };

    try {
      let type = '';
      if (document.isf_doc_level == 'Site') {
        type = `isf_doc_level=${document.isf_doc_level}&isf_doc_country=${document.isf_doc_country}&isf_doc_site=${document.isf_doc_site}&isf_doc_status=${document.isf_doc_status}&document_id=${document.id}`;
      }

      const response: any = await isfInstance.get(
        `${apiConfig.appConfig.apiutilsIsf}/utils/permissions?application=ISF&${type}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }
  async getDocumentInfo(
    documentID: string,
    study: string,
    country: string,
    site: string,
    isfLevel: string,
    application?: any,
    module?: string,
    entity?: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.get(
        `${config.appConfig.apiisf}/isfLevel/${documentID}/getMappedDocument?country_id=${country}&site_id=${site}&study_id=${study}&isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}&parent_entity_related=${entity}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }
  async sendToTMF(
    taskId: string,
    data: any,
    study: string,
    country: string,
    site: string,
    isfLevel: string,
    application?: any,
    module?: string,
    entity?: string,
    is_overwrite?: boolean
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.post(
        `${config.appConfig.apiisf}/Task/approvalWorkflow/${taskId}/updateStatus?country_id=${country}&site_id=${site}&study_id=${study}&isf_doc_level=${isfLevel}&application=${application}&module_section_related=${module}&parent_entity_related=${entity}&is_overwrite=${is_overwrite}`,
        data,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }
  async BulkUpload(overwrite: boolean, module_section_related: string, data: any) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.post(
        `${config.appConfig.apiisf}/isfToTmf/bulkPush?application=ISF&module_section_related=${module_section_related}&is_overwrite=${overwrite}`,
        data,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async VersionBasedDocuments(data: any) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    try {
      const response: any = await isfInstance.post(
        `${config.appConfig.apiisf}/masterDocument/idBasedVersions/getAll?application=ISF`,
        data,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  /**
   * End
   */
}

export default DocManagementService;
